var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    { staticClass: "ma-0 pa-0", attrs: { fluid: "" } },
    [
      _c(
        "v-col",
        { staticClass: "ma-0 pa-0", attrs: { cols: "12" } },
        [
          _c("DashboardHeader"),
          _c(
            "v-col",
            {
              staticClass: "pa-3 pt-8",
              attrs: { id: "main_content_maxwidthset", cols: "12" },
            },
            [
              _c("CCTVStatusBox"),
              _vm.authorities.GET_RECORDING_SUB_BRANCH
                ? _c(
                    "v-col",
                    {
                      staticClass: "ma-0 pa-5 mb-7",
                      attrs: { cols: "12", id: "cctv_player_box" },
                    },
                    [
                      _c(
                        "v-row",
                        {
                          staticClass: "ma-0 pa-0 pl-4 pr-4 mb-2",
                          attrs: { align: "center", justify: "space-between" },
                        },
                        [
                          _c(
                            "v-col",
                            {
                              staticClass: "ma-0 pa-0",
                              staticStyle: { "font-weight": "bold" },
                              attrs: { cols: "auto" },
                            },
                            [_vm._v(" " + _vm._s(_vm.td("cameraList")))]
                          ),
                          _c(
                            "v-row",
                            {
                              staticClass: "ma-0 pa-0",
                              attrs: { align: "center", justify: "end" },
                            },
                            [
                              _c(
                                "v-col",
                                {
                                  staticClass: "ma-0 pa-0 pr-2",
                                  attrs: { cols: "3" },
                                },
                                [
                                  _c("v-select", {
                                    staticClass: "ma-0 pa-1",
                                    attrs: {
                                      items: _vm.priorityList,
                                      dense: "",
                                      "hide-details": "",
                                      outlined: "",
                                      dark: "",
                                      "item-text": "label",
                                      "item-value": "value",
                                    },
                                    model: {
                                      value: _vm.selectedPriority,
                                      callback: function ($$v) {
                                        _vm.selectedPriority = $$v
                                      },
                                      expression: "selectedPriority",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c("VideoThumbnailBox", {
                        attrs: { priority: _vm.selectedPriority },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }